module.exports = __webpack_public_path__ + "img/icon-edit-default.fa85eff2.svg";